// extracted by mini-css-extract-plugin
module.exports = {"vert":"navigation_vert__2rvgs","uppercase":"navigation_uppercase__1p9vF","dashboard":"navigation_dashboard__1Vkk0"};